import React from 'react';

import propTypes from 'prop-types';
import QuickShopContent from './QuickShopContent';

export default class QuickShopPdp extends React.Component {
  static propTypes = {
    selectedVariant: propTypes.ProductVariant,
    changeSelectedVariant: propTypes.func.isRequired,
  };

  componentWillMount() {
    !this.props.selectedVariant &&
      this.props.changeSelectedVariant(this.props.variant);
  }

  render() {
    return (
      this.props.selectedVariant && (
        <QuickShopContent
          showDescription={true}
          productDisplayPage={true}
          {...this.props}
        />
      )
    );
  }
}
